export default __webpack_public_path__ + "static/media/home-page-1.b5d93a08.jpg";